<script lang="ts">
  import clsx from 'clsx'
  import FullScreenMessage from '../FullScreenMessage.svelte'
  import Poster from '../../Poster.svelte'
  import componentAttributes from '../../../stores/componentAttributes.svelte'
  import videoStore from '../../../stores/video.svelte'
  import type { Snippet } from 'svelte'

  type Props = {
    class?: string
    children: Snippet
  }

  let { class: className = '', children }: Props = $props()

  let isPoster = $derived(
    !componentAttributes.state.hidePoster &&
      videoStore.state.mediaDescriptor?.posterUrl,
  )
</script>

<Poster />
<FullScreenMessage
  class={clsx(
    'text-white text-lg text-shadow text-center',
    {
      'bg-black/30': isPoster,
      'bg-black': !isPoster,
    },
    className,
  )}
>
  {@render children?.()}
</FullScreenMessage>
